import {
  Button,
  Checkbox,
  DotsHorizontalIcon,
  Dropdown,
  DropdownMenu,
  ImportIcon,
  LazyLoader,
} from '@bp/ui-components';
import classNames from 'classnames';
import { BpFile } from 'components/Files/hooks/useFiles';
import { formatBytes, getFilenameWithoutExtension, getMimeType } from 'components/Files/utils/fileUtils';
import { t } from 'i18next';
import styles from './FileListEntry.module.scss';

type FileListEntryProps = {
  downloadOnly?: boolean;
  loading: boolean;
  selected: boolean;
  showSelect?: boolean;
  onCopyLink: () => void;
  onDelete: () => void;
  onDownload: () => void;
  onRename: () => void;
  onSelect: (uuid: string, selected: boolean) => void;
  className?: string | undefined;
} & BpFile;

export const FileListEntry = ({
  downloadOnly,
  downloadToken,
  filename,
  loading,
  mediaType,
  publicDownloadToken,
  selected,
  showSelect,
  size,
  uuid,
  onCopyLink,
  onDownload,
  onDelete,
  onRename,
  onSelect,
  className,
}: FileListEntryProps) => {
  const nameWithoutExtension = getFilenameWithoutExtension(filename);

  return (
    <div className={classNames(styles['file-list-entry'], className)}>
      {loading && <LazyLoader embedded className={styles.loader} />}

      <div className={styles.data}>
        <div className={styles.name}>
          {showSelect ? (
            <Checkbox
              name={`select-${uuid}`}
              label={nameWithoutExtension}
              checked={selected}
              onChange={(event) => onSelect(uuid, event.target.checked)}
            />
          ) : (
            nameWithoutExtension
          )}
        </div>
        <div className={styles.info}>
          <div className={styles.type}>{getMimeType(mediaType)}</div>
          <div className={styles.divider} />
          <div className={styles.size}>{formatBytes(size)}</div>
        </div>
      </div>

      <div className={styles.actions}>
        {downloadOnly ? (
          <Button
            hierarchy='ghost'
            icon={<ImportIcon className='small' />}
            onClick={() => onDownload()}
            disabled={!downloadToken}
          />
        ) : (
          <Dropdown
            usePortal={false}
            trigger={<Button hierarchy='ghost' icon={<DotsHorizontalIcon className='small' />} />}
          >
            <DropdownMenu
              data={[
                {
                  label: t('common.rename'),
                  onClick: () => onRename(),
                },
                {
                  label: t('common.download'),
                  onClick: () => onDownload(),
                  disabled: !downloadToken,
                },
                {
                  label: t('common.copyType', { type: 'Link' }),
                  onClick: () => onCopyLink(),
                  disabled: !publicDownloadToken,
                },
                { type: 'ruler' },
                {
                  label: t('common.delete'),
                  color: 'error',
                  onClick: () => onDelete(),
                },
              ]}
            />
          </Dropdown>
        )}
      </div>
    </div>
  );
};
